import React from 'react';
import { Button } from '@gerdau/hefesto/Button';
import { Title } from '@gerdau/hefesto/Title';
import { ConstructionRegistrationResumeBlock } from '../styles';
import { IDeliveryConditions } from '../../../../../store/ducks/contracts-and-constructions/types';
import { weekDayMap } from '../../constructionRegistrationFieldsValidations';
import { DeliveryConditionsContainer } from './styles';

interface IDeliveryConditionsResumeProps {
  deliveryConditions?: IDeliveryConditions;
  onEditClick: () => void;
}

const DeliveryConditionsResume: React.FC<IDeliveryConditionsResumeProps> = ({
  deliveryConditions,
  onEditClick
}) => {
  return (
    <ConstructionRegistrationResumeBlock>
      <header>
        <Title level={2}>Condições de entrega</Title>
        <Button name="edit" variant="secondary" onClick={onEditClick}>
          Editar
        </Button>
      </header>

      <DeliveryConditionsContainer className="">
        <div className="block receipt-time">
          <Title level={6}>Horários de recebimento</Title>

          {deliveryConditions?.allowedDaysAndTimeToReceive
            .filter((dayAndTime) => dayAndTime.checked)
            .map((dayAndTime, idx) => (
              <div key={idx} className="day-and-time">
                <span>{weekDayMap.get(dayAndTime.day)}</span>
                <span>
                  {`das ${dayAndTime.startTime || ' - '} às ${
                    dayAndTime.endTime || ' - '
                  }`}
                </span>
              </div>
            ))}
        </div>

        <div className="block">
          <Title level={6}>Tipo de veículo</Title>

          {deliveryConditions?.allowedVehicleTypes.map(
            (allowedVehicleType, idx) => (
              <span className="description" key={idx}>
                {allowedVehicleType}
              </span>
            )
          )}
        </div>

        <div className="block">
          <Title level={6}>Tipo de descarga</Title>

          <span className="description">
            {deliveryConditions?.allowedDischargeType}
          </span>
        </div>
      </DeliveryConditionsContainer>

      <DeliveryConditionsContainer className="observations">
        <div className="block">
          <Title level={6}>Observações</Title>

          <span className="description">
            {deliveryConditions?.dischargeObservation || ' - '}
          </span>
        </div>
      </DeliveryConditionsContainer>
    </ConstructionRegistrationResumeBlock>
  );
};

export default DeliveryConditionsResume;
